import { i18n } from "@lingui/core";
import $switchCaseDefault from 'dolla-switch';
export const getTooltipUxCopy = reason => $switchCaseDefault(reason, {
  notAllowedClosedPrivacy: () => ({
    title: i18n._("Not allowed to publish"),
    body: i18n._("Document is restricted: only collaborators can access")
  }),
  notAllowedInOrg: () => ({
    title: i18n._("Not allowed to publish"),
    body: i18n._("Publishing a document is disabled for this team by the admin")
  }),
  notAllowedShared: () => ({
    title: i18n._("Not allowed to publish"),
    body: i18n._("Only the owner of the document is allowed to publish")
  }),
  notAllowedWithCurrentLicense: () => ({
    title: i18n._("Privacy control"),
    body: i18n._("Enjoy complete control over who sees your presentations with a Standard, Plus, or Premium license."),
    action: i18n._("Upgrade")
  })
}, () => {
  throw `Invalid component state: ${reason}`;
});